import type { Tone } from '../../../util/term'
import { FILLED_TONES } from './marks'
import ScoreMark from './ScoreMark'

const LegendRow = ({
  tone,
  label,
  gross,
}: {
  tone: Tone
  label: string
  gross: number
  par: number
}) => {
  const isFilled = FILLED_TONES.has(tone)
  return (
    <div className="flex items-center gap-2">
      <div className="relative inline-block" style={{ width: 36, height: 36 }}>
        <ScoreMark tone={tone} size={36} />
        <span
          className="absolute inset-0 flex items-center justify-center font-mono num text-sm font-semibold"
          style={{
            color: isFilled ? 'var(--paper)' : 'var(--ink-900)',
            lineHeight: 1,
            paddingTop: 1,
          }}
        >
          {gross}
        </span>
      </div>
      <span>{label}</span>
    </div>
  )
}

/**
 * Collapsible mark-grammar reference. Shown at the bottom of the
 * scorecard so a new captain can decode the marks at a glance.
 */
const Legend = () => (
  <details className="mx-2 mt-3 bg-paper rounded-lg shadow-sm">
    <summary className="px-4 py-2.5 text-[11px] font-bold text-ink-700 cursor-pointer list-none flex items-center justify-between">
      <span
        style={{
          letterSpacing: 'var(--ls-caps)',
          textTransform: 'uppercase',
        }}
      >
        Forklaring
      </span>
      <span className="text-ink-400 text-sm">▾</span>
    </summary>
    <div className="px-4 pb-4 grid grid-cols-2 gap-y-3 text-xs text-ink-700">
      <LegendRow tone="albatross" label="Albatross / HiO" gross={1} par={4} />
      <LegendRow tone="eagle" label="Eagle" gross={2} par={4} />
      <LegendRow tone="birdie" label="Birdie" gross={3} par={4} />
      <LegendRow tone="bogey" label="Bogey" gross={5} par={4} />
      <LegendRow tone="double" label="Dobbel" gross={6} par={4} />
      <LegendRow tone="triple" label="Trippel+" gross={7} par={4} />
      <div className="col-span-2 flex items-center gap-2 mt-1">
        <span className="w-1.5 h-1.5 rounded-full bg-flag inline-block" />
        <span>Rød prikk = slag fra hcp</span>
      </div>
    </div>
  </details>
)

export default Legend
